module.exports = __webpack_public_path__ + "static/media/PC5-4.dc3a5d72.jpg";